import React from "react";
import "./Gallery.css"; // Import your custom CSS file
// import images from "../../images/imageSsc";
// import Gallery2 from "../Gallery2/Gallery2";

// images/imageEvents.js

const importAll = (r) => r.keys().map(r);
const images = importAll(require.context('../../images/Events', false, /\.(png|jpe?g|svg)$/));

const shuffledImages = images.sort(() => 0.5 - Math.random());


const Gallery = () => {

  return (
    <div style={{ display: "grid" }}>
     <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Gallery
        </span>
      </h1>
      
      <div className="slider2">
        <div className="slide-track">
          {shuffledImages.map((image, index) => (
            <div key={index} className="slide2">
              <img src={image} alt={`Slide ${index}`} className="image" style={{ height: "200px", width: "200px",  padding:"10px" }} />
            </div>
          ))}
        </div>
      </div>
      {/* <Gallery2 /> */}
    </div>
  );
};

export default Gallery;
